import React, { useEffect } from "react";
import { LDProvider as Provider, useLDClient } from "launchdarkly-react-client-sdk";

export const ldContext = {};

const LDClientWatcher = () => {
  const client = useLDClient();

  useEffect(() => {
    if (client) {
      ldContext.client = client;
    }

    return () => {
      delete ldContext.client;
    };
  }, [client]);

  return null;
};

const LDProvider = ({ clientSideID, children }) => (
  <Provider clientSideID={clientSideID}>
    <LDClientWatcher />
    {children}
  </Provider>
);

export default LDProvider;
